'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var inlineBlockStyle = {
  display: 'inline-block'
};

var ReactInlineBlock = function (_React$Component) {
  _inherits(ReactInlineBlock, _React$Component);

  function ReactInlineBlock() {
    _classCallCheck(this, ReactInlineBlock);

    return _possibleConstructorReturn(this, (ReactInlineBlock.__proto__ || Object.getPrototypeOf(ReactInlineBlock)).apply(this, arguments));
  }

  _createClass(ReactInlineBlock, [{
    key: 'render',
    value: function render() {
      var style = (0, _objectAssign2.default)({}, this.props.style, inlineBlockStyle);
      var props = (0, _objectAssign2.default)({}, this.props, { style: style });

      return _react2.default.createElement('div', props);
    }
  }]);

  return ReactInlineBlock;
}(_react2.default.Component);

exports.default = ReactInlineBlock;